module.exports = __webpack_public_path__ + "static/MineralSwimV2_Testimonial_Katie_NSW-b4fac9327cf67e07f2fca7864421e46e.jpg";